export function useTileSelection(tile, modelValue) {

    // Get array of the current screen tile selection object keys
    const tilesObj = Object.keys(modelValue.tileSelection);

    let currentTile = tilesObj.filter(function (propKey) {
        // Return the current key with the value set to true in the model ( this is the previous tile )
        return modelValue.tileSelection[propKey]
    })

    //Check the tile currently active (for when moving from tile to tile)

    for (let each in modelValue.tileSelection) {

        if (modelValue.tileSelection[each] !== modelValue.tileSelection[tile]) {
            modelValue.tileSelection[each] = false;
        }

    }

    modelValue.tileSelection[tile] = !modelValue.tileSelection[tile];

    return currentTile;
}
